import React, { useContext, useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import { StatisticsScreen } from '../estadisticas/StatisticsScreen';
import SettingsScreen from '../configuraciones/SettingsScreen';
import { BarChartOutlined, PowerSettingsNew, TuneOutlined, DehazeOutlined } from '@material-ui/icons';
import TarifasScreen from '../tarifas/TarifasScreen';
import icon from '../../assets/img/icon.png';
import { LoadingContext } from '../../context/Loading';
import { fb } from '../../utils/Firebase';

const drawerWidth = 240;

const DashboardScreen = props => {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = useState(false);

    const { isReady, setIsReady } = useContext(LoadingContext);
    const { history } = props;

    useEffect(() => {
        let subscribed = true;
        subscribed && setTimeout(() => {setIsReady(true);}, 1000);
        //subscribed && setIsReady(true);

        return () => subscribed = false;
    }, []);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleClick = e => {
        setIsReady(false);
        const route = e.currentTarget.id;
        route === 'logout' ? fb.auth().signOut() : history.replace(`/dashboard/${route}`);
    }

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
                style={{ background: '#00365F' }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: open,
                        })}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>Consola de administración</Typography>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <img src={icon} width='110' alt='' />
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    <ListItem button id='estadisticas' onClick={ e => handleClick(e)}>
                        <ListItemIcon>
                            <BarChartOutlined />
                        </ListItemIcon>
                        <ListItemText primary='Estadísticas' />
                    </ListItem>
                </List>
                <ListItem button id='tarifas' onClick={ e => handleClick(e)}>
                    <ListItemIcon>
                        <DehazeOutlined/>
                    </ListItemIcon>
                    <ListItemText primary='Tarifas'/>
                </ListItem>
                <ListItem button id='configuraciones' onClick={ e => handleClick(e)}>
                    <ListItemIcon>
                        <TuneOutlined/>
                    </ListItemIcon>
                    <ListItemText primary='Configuraciones' />
                </ListItem>
                <Divider />
                <ListItem button id='logout' onClick={ e => handleClick(e)}>
                    <ListItemIcon>
                        <PowerSettingsNew/>
                    </ListItemIcon>
                    <ListItemText primary='Cerrar sesión' />
                </ListItem>
            </Drawer>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                    <Router>
                        <Switch>
                            <Route exact path='/dashboard/estadisticas' component={StatisticsScreen} />
                            <Route exact path='/dashboard/configuraciones' render={props => <SettingsScreen isReady={isReady} setIsReady={setIsReady}/>} />
                            <Route exact path='/dashboard/tarifas' component={TarifasScreen} />

                            <Redirect to='/dashboard' />
                        </Switch>
                    </Router>
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        //padding: theme.spacing(3),
        padding: 10
    },
}));

export default DashboardScreen;